<template>
    <span>{{ value }}</span>
</template>

<script>

export default {
  name: 'CellRendererCurrency',
  computed: {
    value () {
      const { value } = this.params;
      const symbol = (this.params.symbol) ? this.params.symbol : '';

      if (!value) {
        return '';
      }

      return symbol+value.toFixed(2);
    }
  }
}
</script>
